import {useCallback, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {getUniqueValueForTransferList} from '../../../../api/EcaServices';
import {RootState} from '../../../../redux/store';

interface UseQueryFieldReturn {
  loading: boolean;
  transferListKeys: string[];
}

export const useQueryFileField = (fieldId: number): UseQueryFieldReturn => {
  const clientId = useSelector(
    (state: RootState) => state.selectedClient.clientId
  );
  const projectId = useSelector((state: RootState) => state.reports.projectId);

  const [state, setState] = useState<{
    loading: boolean;
    transferListKeys: string[];
  }>({
    loading: false,
    transferListKeys: [],
  });

  const getQueryTransferList = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));

    const queryParam = `clientId=${clientId}&projectId=${projectId}`;

    getUniqueValueForTransferList(fieldId, queryParam)
      .then((result) => {
        setState((prevState) => ({
          ...prevState,
          loading: false,
          transferListKeys: result?.data?.data?.uniqueKeys ?? [],
        }));
      })
      .catch(() => {
        setState((prevState) => ({...prevState, loading: false}));
      });
  }, [clientId, fieldId, projectId]);

  useEffect(() => {
    getQueryTransferList();
  }, [getQueryTransferList]);

  return {
    ...state,
  };
};
